import useQRCode from './useQRCode';

export default useQRCode;
